import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import MuseUI from 'muse-ui'
import 'muse-ui/dist/muse-ui.css'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import routes from './routes'
import axios from 'axios';
import VueAxios from 'vue-axios';
import 'font-awesome/css/font-awesome.min.css'


/*import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
Vue.use(ElementUI)*/


Vue.use(MuseUI);
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.config.productionTip = false

// 用 axios 进行 Ajax 请求
Vue.use(VueAxios, axios);

NProgress.configure({showSpinner: false});

const router = new VueRouter({
    mode: 'history',
    routes: routes
})

router.beforeEach((to, from, next) => {
    //NProgress.start();
    /*if (to.path == '/activity') {
        sessionStorage.removeItem('user');
    }*/
    //let user = JSON.parse(sessionStorage.getItem('user'));

    if (to.path == '/wxvue/TEST'||to.path == '/wxvue/orderlessonlist'||to.path == '/wxvue/hotlessoncar'||to.path == '/wxvue/successlesson'||to.path == '/wxvue/hotlessoncheck'||to.path == '/wxvue/hotlessonenroll'||to.path == '/wxvue/hotlessondetail'||to.path == '/wxvue/hotlessonevaluate'||to.path == '/wxvue/hotlessonimgs'||to.path == '/wxvue/hotlessonbox'||to.path == '/wxvue/hotlesson'||
        to.path == '/wxvue/orderevaluatewx'||to.path == '/wxvue/myfollow'||to.path == '/wxvue/activityqareply'||to.path == '/wxvue/orderevaluatesuccess'||to.path == '/wxvue/activityimgs'||to.path == '/wxvue/activitycheck'||to.path == '/wxvue/successactivity'||to.path == '/wxvue/orderenrollinfo'||to.path == '/wxvue/orderevaluate'||to.path == '/wxvue/activityqadetail'||to.path == '/wxvue/activityqalist'||to.path == '/wxvue/activityevaluate'||to.path == '/wxvue/activitydetail'||to.path == '/wxvue/activityinfo'||to.path == '/wxvue/activityenroll'||to.path == '/wxvue/activitypayment'||
        to.path == '/wxvue/communityqyqmap' ||to.path == '/wxvue/communitylqyqmap' ||to.path == '/wxvue/votemain' ||to.path == '/wxvue/votelist' ||to.path == '/wxvue/iseeenroll' ||to.path == '/wxvue/iseesuccess' || to.path == '/wxvue/msj' ||
        to.path == '/wxvue/login' || to.path == '/wxvue/register' || to.path == '/wxvue/resetpassword' || to.path == '/wxvue/editpersonal' || to.path == '/wxvue/mycollect' ||
        to.path == '/wxvue/myfamily' || to.path == '/wxvue/addfamily' || to.path == '/wxvue/editfamily' || to.path == '/wxvue/public' ||
        to.path == '/wxvue/scansign'|| to.path == '/wxvue/bdhenroll'|| to.path == '/wxvue/bdhinfo' || to.path == '/wxvue/yx' || to.path == '/wxvue/bdhpm' || to.path == '/wxvue/hotactivity' || to.path == '/wxvue/hotdetail'|| to.path == '/wxvue/hotcheck' ||
        to.path == '/wxvue/community' || to.path == '/wxvue/communityApp' || to.path == '/wxvue/communitylist' || to.path == '/wxvue/communityThemeType' ||
        to.path == 'jm/wxvue/communitysearchlist' || to.path == '/wxvue/communityThemeList' || to.path == '/wxvue/communityThemeDetaile' ||
        to.path == '/wxvue/communitydetaile' || to.path == '/wxvue/communitycheck' || to.path == '/wxvue/communityenroll' ||
        to.path == '/wxvue/communityannouncement' || to.path == '/wxvue/announcementdetaile' || to.path == '/wxvue/communityedulist' ||
        to.path == '/wxvue/communitypublicdetaile' || to.path == '/wxvue/communityedudetaile' || to.path == '/wxvue/orderlist' ||
        to.path == '/wxvue/orderdetaile' || to.path == '/wxvue/beerskittles' || to.path == '/wxvue/hotactivity' || to.path == '/wxvue/success' || to.path == '/wxvue/success_bdh'||
        to.path == '/wxvue/hotcourse' || to.path == '/wxvue/hotcoursedetaile' || to.path == '/wxvue/hotcoursecheck' ||
        to.path == '/wxvue/outschool' || to.path == '/wxvue/newslist' || to.path == '/wxvue/newsdetaile' || to.path == '/wxvue/outlovelist' ||
        to.path == '/wxvue/outlovelist1' || to.path == '/wxvue/outsearchlist' || to.path == '/wxvue/outlovedetaile' ||
        to.path == '/wxvue/outlovedetaile1' || to.path == '/wxvue/outenroll'|| to.path == '/wxvue/mymain' || to.path == '/wxvue/telbind' || to.path == '/wxvue/applink' || to.path == '/wxvue/404' || to.path == '/wxvue/communitymap') {
        next();
    }
    // else if (!user) {
    //     next({path: '/wxvue/404'});
    // }
    else {
        next({path: '/wxvue/404'});
    }
})

/*router.afterEach(transition => {
    NProgress.done();
});

//axios 设置放在前面，否则刷新页面的时候无效
/*axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// axios.defaults.timeout = 2000;
axios.defaults.withCredentials = true;
//axios.defaults.baseURL = 'http://test.bandou.cn/';
axios.defaults.baseURL = 'https://wx.bandou.cn/';

/*axios.interceptors.request.use((config) => {    // 这里的config包含每次请求的内容
    let user = JSON.parse(sessionStorage.getItem('user'));
    if (user && user.acctoken) {
        config.headers.authorization = user.acctoken;
    }
    return config;
}, (err) => {
    return Promise.reject(err);
});
// Add a response interceptor
axios.interceptors.response.use((response) => {
    if (response.status == 401 || response.data.status == 401) {
        //router.push({path: '/login'});
    }
    return response;
}, (error) => {
    if (error.response.status == 401 || error.response.data.status == 401) {
        //router.push({path: '/login'});
    }
    return Promise.reject(error);
});*/

new Vue({
    //el: '#app',
    //template: '<App/>',
    router,
    store,
    //components: { App }
    render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js